import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var LinkAlt = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M4.222 19.778a4.983 4.983 0 003.535 1.462 4.986 4.986 0 003.536-1.462l2.828-2.829-1.414-1.414-2.828 2.829a3.007 3.007 0 01-4.243 0 3.005 3.005 0 010-4.243l2.829-2.828-1.414-1.414-2.829 2.828a5.006 5.006 0 000 7.071zm15.556-8.485a5.008 5.008 0 000-7.071 5.006 5.006 0 00-7.071 0L9.879 7.051l1.414 1.414 2.828-2.829a3.007 3.007 0 014.243 0 3.005 3.005 0 010 4.243l-2.829 2.828 1.414 1.414 2.829-2.828z",
    key: "k0"
  }), React.createElement("path", {
    d: "M8.464 16.95l-1.415-1.414 8.487-8.486 1.414 1.415z",
    key: "k1"
  }));
});
LinkAlt.displayName = 'LinkAlt';
export var LinkAltDimensions = {
  height: 24,
  width: 24
};